import * as fb from "firebase/app";
import * as fa from "firebase/auth";

import { config } from "@/config";

const firebaseApp = fb.initializeApp(config.firebaseConfig);
const firebaseAuth = fa.getAuth(firebaseApp);
// const firestore = fbfs.getFirestore(firebaseApp);
// const firebaseStorage = fbs.getStorage(firebaseApp);
// const firebaseFunctions = fbf.getFunctions(firebaseApp, "europe-west3");

export { firebaseApp, firebaseAuth };
